import { MenuSection } from "../../components";
import { motion } from "framer-motion";

const Menu = () => {
  return (
    <div className="flex w-full h-auto flex-col items-center justify-center bg-white min-h-screen">
      {/* Hero Section */}
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full text-center py-16 px-4 bg-gradient-to-br from-[#1a1812] via-[#2a2620] to-[#1a1812]"
      >
        <h1 className="text-5xl md:text-7xl font-bold text-[#ac9430] mb-4">
          Our Menu
        </h1>
        <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
          Discover the authentic flavors of South India and Indo-Chinese cuisine
        </p>
        <div className="w-32 h-1.5 bg-gradient-to-r from-[#947d25] to-[#ac9430] mx-auto mt-6 rounded-full"></div>
      </motion.div>

      {/* Menu Section */}
      <MenuSection />

      {/* Footer Note */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        className="w-full text-center py-12 px-4 bg-gray-50"
      >
        <p className="text-gray-600 text-lg">
          All prices are in USD. Menu items and prices subject to change.
        </p>
        <p className="text-gray-600 mt-2">
          Ask about our daily specials and catering options!
        </p>
      </motion.div>
    </div>
  );
};

export default Menu;
